/**
 * Nadmiera, ako ju vidí a zadáva user (KOLO 133).
 *
 * Uložená `nadmiera_x_mm` je k rozmeru **s hranou** — z nej počíta cena,
 * porez, prírez (`cncStav`) aj exporty a to sa nemení. Postup, ktorý ide
 * najprv na CNC (`lep_nc_olep`, `nc_olep`, `lep_nc_olep_nc`), reže holú
 * dosku a dielňa jeho nadmieru číta k nej: `plat` 500×300 má ukazovať
 * +5 / +5, nie +4 / +3,5. Backend preto posiela `nadmiera_posun_*` —
 * o toľko je zobrazená nadmiera väčšia. Pri ostatných postupoch je 0
 * (`olep_nc` ostáva −1 / −1 k rozmeru po olepení).
 */

export type OsNadmiery = "x" | "y";

interface NadmieraDielca {
  nadmiera_x_mm?: string | number | null;
  nadmiera_y_mm?: string | number | null;
  nadmiera_posun_x_mm?: string | number | null;
  nadmiera_posun_y_mm?: string | number | null;
}

function cislo(v: string | number | null | undefined): number {
  const n = typeof v === "number" ? v : parseFloat(String(v ?? "0"));
  return Number.isFinite(n) ? n : 0;
}

/** Stotiny bez chyby desatinnej čiarky (4.1 + 0.9 = 5, nie 4.999…). */
function naStotiny(n: number): number {
  return Math.round(n * 100) / 100;
}

/** Posun zobrazenej nadmiery v osi (0 pri olep_nc, nc a dielci bez hrán). */
export function posunNadmiery(d: NadmieraDielca, os: OsNadmiery): number {
  return cislo(os === "x" ? d.nadmiera_posun_x_mm : d.nadmiera_posun_y_mm);
}

/** Nadmiera, ktorú vidí user: uložená + posun. */
export function zobrazenaNadmiera(d: NadmieraDielca, os: OsNadmiery): number {
  const ulozena = cislo(os === "x" ? d.nadmiera_x_mm : d.nadmiera_y_mm);
  return naStotiny(ulozena + posunNadmiery(d, os));
}

/**
 * Čo uložiť, keď user zadá `zobrazena`: zobrazená − posun, na stotiny.
 * Bez zbytočných núl (`-1.5`, `5`) — pri posune 0 ide presne to, čo user
 * napísal, ako pred KOLOM 133.
 */
export function nadmieraNaUlozenie(
  d: NadmieraDielca,
  os: OsNadmiery,
  zobrazena: string | number,
): string {
  return String(naStotiny(cislo(zobrazena) - posunNadmiery(d, os)));
}
